import lazyWithRetry from "../../../utils/lazyWithRetry";

const TopSoldProducts = lazyWithRetry(() => import("./TopSoldProducts/TopSoldProducts"));
const DynamicReport = lazyWithRetry(() => import("./DynamicReport/DynamicReport"));
const DailyOrders = lazyWithRetry(() => import("./DailyOrders/DailyOrders"));
export {
  TopSoldProducts,
  DynamicReport,
  DailyOrders,
};
